export default function emptyValueFallbackFilter(item, symbol = '-') {
  return item || symbol;
}
